import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import AboutUs from "../pages/About/AboutUs";
import Settings from "../pages/Settings/Settings";
import NotFound from "../pages/NotFound/NotFound";
import HomePage from "../pages/Home/HomePage";
import Privacy from "../pages/Privacy/Privacy";
import Terms from "../pages/Terms/Terms";
import Support from "../pages/Support/Support";
import ProtectedRoute from "./ProtectedRoute";
import Maintenance from "./features/Maintenance/Maintenance";
import Layout from "./layout/Layout";
import Config from "../Config";

export default function SiteRoutes() {
  const location = useLocation();

  // If maintenance mode is enabled, show the maintenance page for all routes
  if (Config.maintenanceMode) {
    return <Maintenance />;
  }

  return (
    <>
      <Routes location={location} key={location.pathname}>
        <Route path="about_us" element={<Layout><AboutUs /></Layout>} />
        <Route path="privacy" element={<Layout><Privacy /></Layout>} />
        <Route path="terms" element={<Layout><Terms /></Layout>} />
        <Route path="support" element={<Layout><Support /></Layout>} />

        <Route path="settings" element={
          <ProtectedRoute>
            <Layout>
              <Settings />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/" element={<HomePage />} />
        <Route path="*" element={<Layout><NotFound /></Layout>} />
      </Routes>
    </>
  );
}
